import { Injectable } from '@angular/core';
import { toUpper, trim } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class TopAnomalyTitleService {
  kpiNameToUserFriendlyNameMap: Record<string, IKpiUserFriendlyName> = {
    bytecount: { name: 'Traffic rate', expression: { '>': 'increase', '<': 'decrease' } },
    packetcount: { name: 'Packet rate', expression: { '>': 'increase', '<': 'decrease' } },
    bytecount1to2: {
      name: 'Outgoing traffic rate',
      expression: { '>': 'increase', '<': 'decrease' }
    },
    bytecount2to1: {
      name: 'Incoming traffic rate',
      expression: { '>': 'increase', '<': 'decrease' }
    },
    packetcount1to2: {
      name: 'Outgoing packet rate',
      expression: { '>': 'increase', '<': 'decrease' }
    },
    packetcount2to1: {
      name: 'Incoming packet rate',
      expression: { '>': 'increase', '<': 'decrease' }
    },
    eueclientscore: { name: 'Client score', expression: { '<': 'degraded' } },
    eueserverscore: { name: 'Server score', expression: { '<': 'degraded' } },
    euenetworkscore: { name: 'Network score', expression: { '<': 'degraded' } },
    eueapplicationscore: { name: 'App score', expression: { '<': 'degraded' } },
    appdelayin: { name: 'App delay client to server', expression: { '>': 'increase' } },
    appdelayout: { name: 'App delay server to client', expression: { '>': 'increase' } },
    networkdelay: { name: 'Network delay', expression: { '>': 'increase' } },
    mosaudioaverage: { name: 'Audio call quality', expression: { '<': 'degraded' } },
    mosvideoaverage: { name: 'Video call quality', expression: { '<': 'degraded' } },
    callsetupduration: { name: 'Call setup time', expression: { '>': 'increase' } },
    gigatestmosaudioaverage: { name: 'Audio call quality', expression: { '<': 'degraded' } },
    gigatestServiceTestCurlTimeNameLookup: {
      name: 'DNS resolution time',
      expression: { '>': 'increase' }
    },
    gigatestServiceTestCurlTimeClient: {
      name: 'Client response time',
      expression: { '>': 'increase' }
    },
    gigatestServiceTestCurlTimeNetwork: {
      name: 'Network response time',
      expression: { '>': 'increase' }
    },
    gigatestServiceTestCurlTimeServer: {
      name: 'Server response time',
      expression: { '>': 'increase' }
    },
    gigatestNetworkQualityPacketDelayFromOriginator: {
      name: 'Delay near to far',
      expression: { '>': 'increase' }
    },
    gigatestNetworkQualityPacketDelayFromDestination: {
      name: 'Delay far to near',
      expression: { '>': 'increase' }
    },
    gigatestNetworkQualityPacketLossFromOriginator: {
      name: 'Frame loss near to far',
      expression: { '>': 'increase' }
    },
    gigatestNetworkQualityPacketLossFromDestination: {
      name: 'Frame loss far to near',
      expression: { '>': 'increase' }
    },
    gigatestNetworkQualityPacketJitterFromOriginator: {
      name: 'Jitter near to far',
      expression: { '>': 'increase' }
    },
    gigatestNetworkQualityPacketJitterFromDestination: {
      name: 'Jitter far to near',
      expression: { '>': 'increase' }
    }
  };

  constructor() {} //eslint-disable-line

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructAnomalyTitle(anomaly: any) {
    const userFriendlyKpiName = this.kpiNameToUserFriendlyNameMap[anomaly.kpiName];
    const fullName = userFriendlyKpiName
      ? userFriendlyKpiName.name +
        ' ' +
        userFriendlyKpiName.expression[anomaly.expression] +
        ' ' +
        this.getDimensionName(anomaly)
      : anomaly.kpiName;

    return trim(fullName);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  getDimensionName(anomaly: any, type?: any) {
    if (type === 'siteresourceid') {
      return anomaly.siteName;
    } else if (type === 'appresourceid') {
      return anomaly.appName;
    }
    // there is a huge variety in 'site' resource field name (srcsiteresourceid, siteresourceid, ....)
    // to be resilient to that, simply check for keyword in field name.
    let dimensionId = '';
    dimensionId += toUpper(anomaly.dimensions).indexOf('APP') > -1 ? 'app;' : '';
    dimensionId += toUpper(anomaly.dimensions).indexOf('SITE') > -1 ? 'site;' : '';

    const dimensions = {
      'site;': 'at ' + anomaly.siteName,
      'app;': 'for ' + anomaly.appName,
      'app;site;': 'for ' + anomaly.appName + ' at ' + anomaly.siteName
    };
    const outputLabel = dimensions[dimensionId];
    if (!outputLabel) {
      return '';
    }
    return outputLabel;
  }
}

export interface IKpiUserFriendlyName {
  name: string;
  expression: any; //eslint-disable-line
}
